import React, { ReactNode } from 'react';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { useSettingsContext } from '../context/settings/useSettingsContext';

type TProps = { children: ReactNode };

const I18nProvider: React.FC<TProps> = ({ children }) => {
    const {
        locale: overrides,                 // e.g. { nl: { translations: { key: 'waarde' } } }
    } = useSettingsContext();

    const defaults = require('./locales/nl.json');
    const locale = { ...defaults, ...JSON.parse(overrides) };
    const resources = {
        nl: {
            translations: locale,
        },
    };

    if (!i18n.isInitialized) {
        i18n
            .use(initReactI18next)
            .init({
                lng: 'nl',
                fallbackLng: 'en',
                resources: resources,
                ns: ['translations'],
                defaultNS: 'translations',
            });
    }

    return <>{children}</>;
};

export default I18nProvider;
